module.exports = __webpack_public_path__ + "img/9788949120881.669daa01.jpg";